(() => {
  const toggleButtons = document.querySelectorAll('[data-crumbs-toggle]');

  toggleButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      const crumbsEl = button.closest('.crumbs');
      if (crumbsEl) {
        crumbsEl.classList.add('crumbs--expanded');
      }
      e.preventDefault();
    });
  });
})();
